import React from 'react';
import { useAnalytics, useRequestUrl } from '../hooks';
import { GenericShareButton, InnerShareButton } from './social-sharing.styles';
import { TwitterIcon } from './icons';
export function TwitterShareButton({ block = false, buttonColor = '#1DA1F2', //twitter brand blue
buttonText = 'Twitter', buttonTextColor = 'white', hashtags = [], iconColor = 'white', message, shareUrl = useRequestUrl() }) {
    const { sendTrackEvent } = useAnalytics();
    const params = {
        text: message,
        url: shareUrl,
        related: 'trello'
    };
    const queryString = new URLSearchParams(hashtags.length
        ? Object.assign(Object.assign({}, params), { hashtags: hashtags
                .map((hashtag) => hashtag.replace('#', ''))
                .join(',') }) : params);
    const url = `https://twitter.com/intent/tweet?${queryString}`;
    return (React.createElement(GenericShareButton, { block: block, buttonColor: buttonColor, colorOverride: buttonTextColor, href: url, title: "Twitter", onClick: () => sendTrackEvent('clickedAnchor', {
            event: 'clicked',
            eventComponent: 'TwitterShareButton',
            label: buttonText,
            href: url
        }) },
        React.createElement(InnerShareButton, null,
            React.createElement(TwitterIcon, { color: iconColor }),
            React.createElement("span", null, buttonText))));
}
//# sourceMappingURL=TwitterShareButton.js.map